import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { BsXLg, BsDownload } from "react-icons/bs";
import Loading from "../../../StyledComponents/Loading";
import { useReactToPrint } from "react-to-print";
import GeneratePdf from "./reportGenerator";
import { AiOutlinePrinter } from "react-icons/ai";
import {
  Modal,
  ModalContainer,
  ModalHeader,
  SpanCont,
  Div,
  ModalBody,
  Image,
  PageTitle,
  Text,
  Table,
  TableHead,
  TableRow,
  TableHeadCell,
  TableBody,
  TableBodyCell,
  Button,
} from "../../../StyledComponents";
import {
  ModalDiag,
  PaidStatus,
  InvoiceContainer,
  HeaderSection,
  LogoContainer,
  LogoText,
  InvoiceTitle,
  InvoiceMeta,
  MetaLabel,
  GridContainer,
  InfoCard,
  CardLabel,
  CardName,
  CardDetail,
  StyledTable,
  StyledThread,
  StyledTh,
  StyledTd,
  FooterSection,
  TotalRow,
  TotalLabel,
  TotalValue,
  Divider,
  PaymentInfo,
} from "../styles";
import MakePayment from "../../../StyledComponents/MakePayment";
import StripeAlert from "../../../StyledComponents/StripeAlert";
import { toast } from "react-toastify";
import Error from "../../../StyledComponents/Toastify/Error";
const InvoicePopup = (props) => {
  const componentRef = useRef();
  const [MakePay, setMakePay] = useState(false);
  const [OneInvoiceList, setOneInvoiceList] = useState([]);
  let backurl = "";
  let firstDot = window.location.hostname.split(".");
  let DBhost;
  if (firstDot[0] !== "localhost") {
    backurl = process.env.REACT_APP_BACKEND_FILE_ACCESS.replace(
      "oemr",
      firstDot[0]
    );
  } else {
    backurl = process.env.REACT_APP_BACKEND_FILE_ACCESS;
  }
  if (
    firstDot[0] === "localhost" ||
    firstDot[0] === "test" ||
    firstDot[0] === "mumbai" ||
    firstDot[0] === "production" ||
    firstDot[0] === "ehr" ||
    firstDot[0] === "ehr1" ||
    firstDot[0] === "dev"
  ) {
    DBhost = "default";
  } else {
    DBhost = firstDot[0];
  }
  const File_URL = backurl + "/sites/" + DBhost + "/documentimg/";

  const InvoiceData = useSelector((state) => state.Billing.singleInvoice);
  const Loadings = useSelector((state) => state.Billing.Loading);
  const Ext = useSelector((state) => state.Billing.ext);
  const Base = useSelector((state) => state.Billing.base64);
  const statelogo = useSelector((state) => state.Billing.stateLogo);
  const symbol = useSelector((state) => state.Billing.symbol);
  const [cardDetails, setCardDetails] = useState([]);
  const stripeAllowed = useSelector((state) => state.Billing.stripeAllowed);
  const [ModalAlerShow, setModalAlerShow] = useState(false);
  const [logoExists, setLogoExists] = useState(true);

  const formattedInvoiceDate = new Date(props.Data.invoice_date).toLocaleDateString("en-US", {
    month: "long",
    day: "2-digit",
    year: "numeric",
  });

  const formattedInvoiceData = InvoiceData.map((row) => ({
    ...row,
    date: new Date(row.date)
      .toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      })
      .replaceAll("/", "-"),
  }));

  const handleDownload = () => {
    GeneratePdf(
      formattedInvoiceData,
      props.Data.invoice_id,
      formattedInvoiceDate,
      props.Data.providerName,
      props.Data.facilityname,
      props.Data.ProviderStreet,
      props.Data.ProviderCity,
      props.Data.ProviderState,
      props.Data.ProviderTaxid,
      props.Data.ProviderEmail,
      props.Data.PatName,
      props.Data.PatCell,
      props.Data.PatStreet,
      props.Data.PatCity,
      props.Data.PatState,
      props.Data.Patzip,
      props.Data.PatEmail,
      props.Data.total_amount,
      props.Data.total_balance,
      Ext,
      Base,
      statelogo,
      symbol
    );
  };

  const HandlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handlePayment = () => {
    if (stripeAllowed === false) {
      setModalAlerShow(true);
    } else {
      if (cardDetails.length === 0) {
        toast(<Error msg={`Add Your Card Details then Make a Payment`} />, {
          containerId: "B",
          className: "error_badge",
        });
      } else {
        setMakePay(true);
      }
    }
  };

  const handleModalClick = () => {
    setModalAlerShow(false);
  };

  useEffect(() => {
    let a = [];
    a.push(props.Data);
    setOneInvoiceList(a);
    setCardDetails(props.cardDetails);
  }, [props, InvoiceData]);

  useEffect(() => {
    if (props.show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Cleanup when component unmounts
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [props.show]);

  return (
    <>
      <Modal show={props.show}>
        {Loadings ? (
          <Loading height="100vh" />
        ) : (
          <ModalContainer justifyContent="center">
            <ModalDiag animation={true}>
              <ModalHeader borderLess>
                <Div
                  justifyContent="space-between"
                  display="flex"
                  padding="12px"
                  width="100%"
                  height="100%"
                  boxShadow="0px 1px 8px rgba(20, 46, 110, 0.1)"
                >
                  <Div padding="16px">
                    <BsXLg
                      style={{
                        color: "#718096",
                        cursor: "pointer",
                        height: "16px",
                        width: "16px",
                      }}
                      onClick={() => props.onHide()}
                      id="bil_inv-lst_cls"
                    />
                    <SpanCont
                      fontFamily="inter"
                      color="#2D3748;"
                      fontWeight="600"
                      fontSize="20px"
                      lineHeight="24.2px"
                      marginLeft="36px"
                    >
                      Invoice for&nbsp;{props.Data.PatName}
                    </SpanCont>
                  </Div>

                  <Div display="flex">
                    <Div
                      alignItems="center"
                      display="flex"
                      style={{ borderRight: "1px solid #EBEAED" }}
                    >
                      <AiOutlinePrinter
                        style={{
                          color: "#718096",
                          cursor: "pointer",
                          height: "24px",
                          width: "24px",
                          // marginTop: "17px",
                          marginRight: "20px",
                        }}
                        onClick={HandlePrint}
                      />
                      <BsDownload
                        style={{
                          color: "#718096",
                          cursor: "pointer",
                          height: "24px",
                          width: "24px",
                          // marginTop: "17px",
                          marginRight: "20px",
                        }}
                        onClick={handleDownload}
                      />
                    </Div>
                    <Div
                      marginLeft="20px"
                      alignItems="center"
                      display="flex"
                      marginRight="28px"
                    >
                      <Button
                        color="#ffffff"
                        background="#26BF71"
                        border="1px solid #26BF71"
                        borderRadius="4px"
                        padding="7px 11.5px"
                        fontWeight="500"
                        fontSize="14px"
                        lineHeight="16px"
                        fontFamily="Inter,sans-serif"
                        onClick={handlePayment}
                        disabled={props.Data.total_balance === "0.00" && true}
                      >
                        Add Payment
                      </Button>
                    </Div>
                  </Div>
                </Div>
              </ModalHeader>
              <ModalBody backgroundColor="#f7f7f7" padding="26px 0px">
                {/* Printable Invoice Container */}
                <InvoiceContainer ref={componentRef}>

                  {props.Data.total_balance === "0.00" && (
                    <PaidStatus>PAID</PaidStatus>
                  )}

                  {/* Header: Logo & Invoice Meta */}
                  <HeaderSection>
                    <LogoContainer>
                      {statelogo !== "0" && logoExists ? (
                        <Image
                          loading="lazy"
                          id="canvasportal"
                          width="120px"
                          src={File_URL + Ext}
                          onError={() => setLogoExists(false)}
                        />
                      ) : null}
                    </LogoContainer>
                    <Div>
                      <InvoiceTitle>INVOICE</InvoiceTitle>
                      <InvoiceMeta>
                        <Div>
                          <MetaLabel>Invoice No:</MetaLabel>
                          <span style={{ color: "#2D3748", fontWeight: "600" }}>#{props.Data.invoice_id}</span>
                        </Div>
                        <Div>
                          <MetaLabel>Invoice Date:</MetaLabel>
                          <span style={{ color: "#2D3748", fontWeight: "600" }}> {formattedInvoiceDate}</span>
                        </Div>
                      </InvoiceMeta>
                    </Div>
                  </HeaderSection>

                  {/* 2x2 Grid for Addresses */}
                  <GridContainer>
                    {/* Card 1: Billed From */}
                    <InfoCard>
                      <CardLabel>Billed From:</CardLabel>
                      <CardName>{props.Data.facilityname}</CardName>
                      <CardDetail>
                        {props.Data.ProviderStreet && `${props.Data.ProviderStreet}, `}
                        {props.Data.ProviderCity} {props.Data.ProviderState}
                      </CardDetail>
                      <CardDetail>Email: {props.Data.ProviderEmail}</CardDetail>
                    </InfoCard>

                    {/* Card 2: Billed To */}
                    <InfoCard>
                      <CardLabel>Billed To:</CardLabel>
                      <CardName>{props.Data.PatName}</CardName>
                      <CardDetail>
                        {props.Data.PatStreet && `${props.Data.PatStreet}, `}
                        {props.Data.PatCity}, {props.Data.PatState} {props.Data.Patzip}
                      </CardDetail>
                      <CardDetail>Email: {props.Data.PatEmail}</CardDetail>
                    </InfoCard>

                    {/* Card 3: Provider */}
                    <InfoCard>
                      <CardLabel>Provider:</CardLabel>
                      <CardName>{props.Data.providerName}</CardName>
                      <CardDetail>Tax ID: {props.Data.ProviderTaxid}</CardDetail>
                      {/* Phone not always available in props, adding placeholder or skipping */}
                    </InfoCard>

                    {/* Card 4: Client */}
                    <InfoCard>
                      <CardLabel>Client:</CardLabel>
                      <CardName>{props.Data.PatName}</CardName>
                      <CardDetail>Email: {props.Data.PatEmail}</CardDetail>
                      <CardDetail>Phone: {props.Data.PatCell}</CardDetail>
                    </InfoCard>
                  </GridContainer>

                  {/* Items Table */}
                  <StyledTable>
                    <StyledThread>
                      <tr>
                        <StyledTh>Date</StyledTh>
                        <StyledTh>Description</StyledTh>
                        <StyledTh align="center">Units</StyledTh>
                        <StyledTh align="right">Total</StyledTh>
                      </tr>
                    </StyledThread>
                    <tbody>
                      {InvoiceData.map((row, i) => (
                        <tr key={i}>
                          <StyledTd>  {new Date(row.date).toLocaleDateString("en-US", {
                            month: "2-digit",
                            day: "2-digit",
                            year: "numeric",
                          }).replaceAll("/", "-")}</StyledTd>
                          <StyledTd>{row.serviceName}</StyledTd>
                          <StyledTd align="center">1</StyledTd>
                          <StyledTd align="right">
                            {/* Assuming fee is the total per line item */}
                            {symbol}{row.fee}
                          </StyledTd>
                        </tr>
                      ))}
                    </tbody>
                  </StyledTable>

                  {/* Footer & Totals */}
                  <FooterSection>
                    <TotalRow>
                      <TotalLabel>Total</TotalLabel>
                      <TotalValue>{symbol}{props.Data.total_amount}</TotalValue>
                    </TotalRow>
                    <Divider />
                    <PaymentInfo>
                      Make Payment to: <span style={{ color: "#2D3748" }}>{props.Data.facilityname}</span>
                    </PaymentInfo>
                  </FooterSection>

                  {/* Footer Branding */}
                  <Div display="flex" justifyContent="center" marginTop="50px">
                    <SpanCont
                      fontSize="14px"
                      color="#A0AEC0"
                      fontFamily="inter"
                    >
                      Powered By Vozo
                    </SpanCont>
                  </Div>

                </InvoiceContainer>
              </ModalBody>
            </ModalDiag>
          </ModalContainer>
        )}
      </Modal>
      {MakePay && (
        <MakePayment
          show={MakePay}
          ModalHide={() => setMakePay(false)}
          makepayment="no"
          InvoiceList={OneInvoiceList}
          defaultcardcheck={props.defaultcardcheck}
          CardDetails={cardDetails}
          patient_balance={props.Data.total_balance}
        />
      )}
      {ModalAlerShow && (
        <StripeAlert show={ModalAlerShow} handleModalClick={handleModalClick} />
      )}
    </>
  );
};

export default InvoicePopup;